import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type ProductTourContextValue = {
  /** Increments so ProductTour can start a manual run (e.g. from Profile). */
  manualTourRequest: number;
  requestManualTour: () => void;
};

const ProductTourContext = createContext<ProductTourContextValue | null>(null);

export function ProductTourProvider({ children }: { children: ReactNode }) {
  const [manualTourRequest, setManualTourRequest] = useState(0);
  const requestManualTour = useCallback(() => {
    setManualTourRequest((n) => n + 1);
  }, []);

  return (
    <ProductTourContext.Provider value={{ manualTourRequest, requestManualTour }}>
      {children}
    </ProductTourContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- hook paired with ProductTourProvider
export function useProductTourContext(): ProductTourContextValue {
  const ctx = useContext(ProductTourContext);
  if (!ctx) {
    throw new Error('useProductTourContext must be used within ProductTourProvider');
  }
  return ctx;
}
